const TABLE_NAME = "DocumentManager";

export enum DATA_LINK {
  DMDBInfo = "/Tables/DocumentManager/Info",
  DMList = `/Tables/DocumentManager/List`,
  DMAdd = `/Tables/DocumentManager/Add`,
  DMDelete = `/Tables/DocumentManager/Delete`,
  DMEdit = `/Tables/DocumentManager/Edit`,
  DMUpload = "Tables/DocumentManager/Upload",
  DMExport = `/Tables/DocumentManager/Export`,
  DMImport = `/Tables/DocumentManager/Import`,
  DMDeleteBulk = `/Tables/DocumentManager/DeleteBulk`,
  DMGetContext = "/Tables/DocumentManager/GetContext",
  DMGetEmbeddings = "/Tables/DocumentManager/GetEmbeddings",
  DMGetPrcessedText = "/Tables/DocumentManager/GetProcessedText",
  DMTalk2GPT = "/Tables/DocumentManager/Talk2GPT",
  DMTalk2GPTAsync = "/Tables/DocumentManager/Talk2GPTAsync",
  DMTalk2VA_HYBRID = "/Tables/DocumentManager/Talk2VAHybrid",
  DMTalk2GPT_STREAM = "/Tables/DocumentManager/GetGPTResponseChunk",
  DMReference = "/Tables/DocumentManager/GetReference",
  DMFollowupQuestion = "/Tables/DocumentManager/GetFollowupQuestion",
  DMRemove_History = "/Tables/DocumentManager/RemoveHistory",
  DMSync = "/Tables/DocumentManager/Sync",

  //GPTConvLog
  GPTConvList = `/Tables/GPTConvlog/List`,

  //Intenet
  IntentList = `/Tables/Intent/List`,

  //System
  SYSGPTConfig = `/Config/GPTSystem/Info`,

  //Feedback
  UserFeedback = `/Tables/GPTConvlog/Feedback`,

  //Disclaimer
  GetDisclaimer = "/Tables/DocumentManager/Disclaimer",
}
